<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.575 15.55C11.4417 15.55 11.3167 15.5292 11.2 15.4875C11.0833 15.4458 10.975 15.375 10.875 15.275L6.275 10.675C6.09167 10.4917 6 10.2583 6 9.975C6 9.69167 6.09167 9.45833 6.275 9.275C6.45833 9.09167 6.69167 9 6.975 9C7.25833 9 7.49167 9.09167 7.675 9.275L11.575 13.175L15.475 9.275C15.6583 9.09167 15.8917 9 16.175 9C16.4583 9 16.6917 9.09167 16.875 9.275C17.0583 9.45833 17.15 9.69167 17.15 9.975C17.15 10.2583 17.0583 10.4917 16.875 10.675L12.275 15.275C12.175 15.375 12.0667 15.4458 11.95 15.4875C11.8333 15.5292 11.7083 15.55 11.575 15.55Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#5C5957",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
